<h3 color="primary" class="popup-header">Case Info</h3>
<mat-dialog-content class="mat-typography">

  <ng-template #resultTemplate let-data>
    <div fxLayout="row">
      <div fxFlex="60">
        <mat-form-field fxFill>
          <input matInput type="number" onKeyPress="if(this.value.length==7) return false;"
            [(ngModel)]="data.concentration" disabled />
        </mat-form-field>
      </div>
      <div fxFlex="40" class="align-self-center text-center"
        [ngClass]="data?.result === 'CL' || data?.result === 'CH' ? 'required-section' : ''">
        {{data?.result}}
      </div>
    </div>
  </ng-template>

  <ng-template #commentsTemplate let-data>
    <button mat-icon-button color="primary" [matTooltip]="data.commentTooltip">
      <mat-icon>comment</mat-icon>
    </button>
  </ng-template>

  <ng-template #priorityTemplate let-data>
    <mat-form-field fxFill>
      <mat-select disableOptionCentering [(ngModel)]="data.priority" disabled>
        <mat-option>
          <ngx-mat-select-search [(ngModel)]="searchCtrlForPriority" [placeholderLabel]="'Search...'"
            [noEntriesFoundLabel]="'Not found'" name="search">
          </ngx-mat-select-search>
        </mat-option>
        <mat-option *ngFor="let item of sharedService.priorityList | stringFilterBy:searchCtrlForPriority:'name'"
          [value]="item.id">
          {{item?.name}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </ng-template>

  <ng-template #verifiedTemplate let-data>
    <button *ngIf="data?.verified" mat-icon-button style="color: green;">
      <mat-icon>verified</mat-icon>
    </button>
    <button *ngIf="!data?.verified" mat-icon-button style="color: red;">
      <mat-icon>block</mat-icon>
    </button>
  </ng-template>

  <ng-template #referenceTestTemplate let-data>
    <mat-checkbox [(ngModel)]="data.referenceTest" disabled></mat-checkbox>
  </ng-template>


  <ng-container *ngIf="isCaseOrderInfo">
    <div class="section-content" fxLayout="row wrap" fxLayout.sm="column" fxLayout.xs="column">
      <mat-card class="generalInfo">
        <mat-card-header>
          <mat-card-title>
            <span class="card-title-text">Case Info</span>
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <ul class="generalInfo_details">
            <div fxLayout="row wrap" fxLayout.sm="column" fxLayout.xs="column">
              <li fxFlex="11">Date Collected</li>
              <li fxFlex="2"> : </li>
              <li fxFlex="20" primaryColor>{{caseInfo?.dateCollected | date:'MM/dd/yyyy'}}</li>

              <li fxFlex="11">Collected Time</li>
              <li fxFlex="2"> : </li>
              <li fxFlex="20" primaryColor>{{caseInfo?.collectedTime | date:'h:mm a'}}</li>

              <li fxFlex="13">Date Received</li>
              <li fxFlex="2"> : </li>
              <li fxFlex="18" primaryColor>{{caseInfo?.dateReceived | date:'MM/dd/yyyy'}}</li>
            </div>

            <div fxLayout="row wrap" fxLayout.sm="column" fxLayout.xs="column">
              <li fxFlex="11">Reference</li>
              <li fxFlex="2"> : </li>
              <li fxFlex="20" primaryColor>{{caseInfo?.referenceNumber}}</li>

              <li fxFlex="15">Accession / Order Number</li>
              <li fxFlex="2"> : </li>
              <li fxFlex="16" primaryColor>{{caseInfo?.orderNumber}}</li>

              <li fxFlex="13">Preferred Lab Name</li>
              <li fxFlex="2"> : </li>
              <li fxFlex="18" primaryColor>{{caseInfo?.preferredLabName}}</li>
            </div>

            <div fxLayout="row wrap" fxLayout.sm="column" fxLayout.xs="column">
              <li fxFlex="11">Practice</li>
              <li fxFlex="2"> : </li>
              <li fxFlex="20" primaryColor>{{caseInfo?.labClientName}}</li>

              <li fxFlex="11">Location</li>
              <li fxFlex="2"> : </li>
              <li fxFlex="20" primaryColor>{{caseInfo?.physicianLocation}}</li>

              <li fxFlex="13">Ordering Provider</li>
              <li fxFlex="2"> : </li>
              <li fxFlex="18" primaryColor>{{caseInfo?.physicianName}}</li>
            </div>

            <div fxLayout="row wrap" fxLayout.sm="column" fxLayout.xs="column">
              <li fxFlex="11">Case Number</li>
              <li fxFlex="2"> : </li>
              <li fxFlex="20" primaryColor>{{caseInfo?.caseNo}}</li>

              <li fxFlex="11">ICD Codes</li>
              <li fxFlex="2"> : </li>
              <li fxFlex="20" primaryColor>{{caseInfo?.icdcodes}}</li>

              <li fxFlex="13">Clinical History</li>
              <li fxFlex="2"> : </li>
              <li fxFlex="18" primaryColor>{{caseInfo?.clinicalHistory}}</li>
            </div>

            <div fxLayout="row wrap" fxLayout.sm="column" fxLayout.xs="column">
              <li fxFlex="11">G Codes</li>
              <li fxFlex="2"> : </li>
              <li fxFlex="20" primaryColor>{{caseInfo?.gCodes}}</li>

              <li fxFlex="11">Billing Lab Name</li>
              <li fxFlex="2"> : </li>
              <li fxFlex="20" primaryColor>{{caseInfo?.billingLabName}}</li>

              <li fxFlex="13">Processing Lab Name</li>
              <li fxFlex="2"> : </li>
              <li fxFlex="18" primaryColor>{{caseInfo?.processingLabName}}</li>
            </div>

            <div fxLayout="row wrap" fxLayout.sm="column" fxLayout.xs="column">
              <li fxFlex="11">Status</li>
              <li fxFlex="2"> : </li>
              <li fxFlex="20" primaryColor>{{caseInfo?.statusFlag}}</li>

              <li fxFlex="11">QC</li>
              <li fxFlex="2"> : </li>
              <li fxFlex="20" primaryColor>{{caseInfo?.qc ? 'True' : 'False'}}</li>

              <li fxFlex="13">Eligibility Check</li>
              <li fxFlex="2"> : </li>
              <li fxFlex="18" primaryColor>{{caseInfo?.eligibiligyCheck ? 'True' : 'False'}}</li>
            </div>

            <div fxLayout="row wrap" fxLayout.sm="column" fxLayout.xs="column">
              <li fxFlex="11">LCD Check</li>
              <li fxFlex="2"> : </li>
              <li fxFlex="20" primaryColor>{{caseInfo?.lCDCheck ? 'True' : 'False'}}</li>

              <li fxFlex="11">Billing Verified</li>
              <li fxFlex="2"> : </li>
              <li fxFlex="20" primaryColor>{{caseInfo?.readyForBilling ? 'True' : 'False'}}</li>

              <li fxFlex="13">WorkerComp</li>
              <li fxFlex="2"> : </li>
              <li fxFlex="18" primaryColor>{{caseInfo?.workCompTypeName}}</li>
            </div>

            <div fxLayout="row wrap" fxLayout.sm="column" fxLayout.xs="column">
              <li fxFlex="11">CPT Codes</li>
              <li fxFlex="2"> : </li>
              <li fxFlex="87" primaryColor>{{caseInfo?.cptcodes}}</li>
            </div>

            <div fxLayout="row wrap" fxLayout.sm="column" fxLayout.xs="column">
              <li fxFlex="11">Prescibed Drugs</li>
              <li fxFlex="2"> : </li>
              <li fxFlex="87" primaryColor>{{caseInfo?.caseDrugsName}}</li>
            </div>

            <div fxLayout="row wrap" fxLayout.sm="column" fxLayout.xs="column">
              <li fxFlex="11">Adjuster</li>
              <li fxFlex="2"> : </li>
              <li fxFlex="87" primaryColor>{{caseInfo?.adjusterInfo}}</li>
            </div>
          </ul>
        </mat-card-content>
      </mat-card>
    </div>

    <div class="section-content" fxLayout="row wrap" fxLayout.sm="column" fxLayout.xs="column">
      <mat-card class="generalInfo">
        <mat-card-header>
          <mat-card-title>
            <span class="card-title-text">Patient Info</span>
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <ul class="generalInfo_details">
            <div fxLayout="row wrap" fxLayout.sm="column" fxLayout.xs="column">
              <li fxFlex="11">Last Name</li>
              <li fxFlex="2"> : </li>
              <li fxFlex="20" primaryColor>{{patientInfo?.patientLastName}}</li>

              <li fxFlex="11">First Name</li>
              <li fxFlex="2"> : </li>
              <li fxFlex="20" primaryColor>{{patientInfo?.patientFirstName}}</li>

              <li fxFlex="11">DOB</li>
              <li fxFlex="2"> : </li>
              <li fxFlex="20" primaryColor>{{patientInfo?.dateOfBirth | date:'MM/dd/yyyy'}}</li>
            </div>

            <div fxLayout="row wrap" fxLayout.sm="column" fxLayout.xs="column">
              <li fxFlex="11">Gender</li>
              <li fxFlex="2"> : </li>
              <li fxFlex="20" primaryColor>{{patientInfo?.gender}}</li>

              <li fxFlex="11">Address 1</li>
              <li fxFlex="2"> : </li>
              <li fxFlex="20" primaryColor>{{patientInfo?.patientAddress1}}</li>

              <li fxFlex="11">Address 2</li>
              <li fxFlex="2"> : </li>
              <li fxFlex="20" primaryColor>{{patientInfo?.patientAddress2}}</li>
            </div>

            <div fxLayout="row wrap" fxLayout.sm="column" fxLayout.xs="column">
              <li fxFlex="11">City</li>
              <li fxFlex="2"> : </li>
              <li fxFlex="20" primaryColor>{{patientInfo?.patientCity}}</li>

              <li fxFlex="11">State</li>
              <li fxFlex="2"> : </li>
              <li fxFlex="20" primaryColor>{{patientInfo?.patientState}}</li>

              <li fxFlex="11">Zip</li>
              <li fxFlex="2"> : </li>
              <li fxFlex="20" primaryColor>{{patientInfo?.patientZip}}</li>
            </div>
          </ul>
        </mat-card-content>
      </mat-card>
    </div>

    <div class="section-content" fxLayout="row wrap" fxLayout.sm="column" fxLayout.xs="column">
      <mat-card class="generalInfo">
        <mat-card-header>
          <mat-card-title>
            <span class="card-title-text">Specimen Info</span>
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <ul class="generalInfo_details">
            <div fxLayout="row wrap" fxLayout.sm="column" fxLayout.xs="column">
              <li fxFlex="8">Specimen Type</li>
              <li fxFlex="2"> : </li>
              <li fxFlex="23" primaryColor>
                {{(caseInfo?.caseSpecimens && caseInfo?.caseSpecimens.length > 0) ?
                caseInfo?.caseSpecimens[0]?.specimenTypeName : ''}}
              </li>

              <ng-container *ngIf="caseInfo?.caseType > 0">
                <li fxFlex="8">Case Type</li>
                <li fxFlex="2"> : </li>
                <li fxFlex="23" primaryColor>
                  {{caseInfo?.caseType == 1 ? 'Chemistry' : ''}}
                  {{caseInfo?.caseType == 2 ? 'Hematology' : ''}}
                </li>
              </ng-container>

              <li fxFlex="8">Profile</li>
              <li fxFlex="2"> : </li>
              <li fxFlex="23" primaryColor>
                {{(caseInfo?.caseSpecimens && caseInfo?.caseSpecimens.length > 0 &&
                caseInfo?.caseSpecimens[0]?.caseSpecimenPanels) ?
                caseInfo?.caseSpecimens[0]?.caseSpecimenPanels[0]?.profileName : ''}}
              </li>
            </div>
          </ul>

          <ng-container
            *ngIf="caseInfo?.caseSpecimens && caseInfo?.caseSpecimens.length > 0 && caseInfo?.caseSpecimens[0]?.caseResults && caseInfo?.caseSpecimens[0]?.caseResults.length > 0">
            <ejs-grid [dataSource]='caseInfo?.caseSpecimens[0]?.caseResults' [enableInfiniteScrolling]='true'
              [allowFiltering]="true" [allowResizing]="true" [allowGrouping]='true' [groupSettings]='groupOptions'
              [pageSettings]="pageSettings">
              <e-columns>
                <e-column field='class' headerText='Test Screen' width=60></e-column>
                <e-column field='compound' headerText='Compound Name' width=60></e-column>
                <e-column field='cutOff' headerText='Cut Off' width=60>
                  <ng-template #template let-data>
                    {{data?.cutOff}} {{data?.cutOff ? data?.units : ''}}
                  </ng-template>
                </e-column>
                <e-column field='result' headerText='Result' width=60></e-column>
                <e-column field='concentration' headerText='Concentration' width=60>
                  <ng-template #template let-data>
                    {{data?.concentration}} {{data?.concentration ? data?.units : ''}}
                  </ng-template>
                </e-column>
                <e-column field='comments' headerText='Comments' width=60></e-column>
              </e-columns>
              <ng-template #groupSettingsCaptionTemplate let-data>
                <span class='groupHeader' *ngIf="data?.items.length > 0">{{data?.key}}</span>
              </ng-template>
            </ejs-grid>
            <app-total-record-count [count]="caseInfo?.caseSpecimens[0]?.caseResults.length"></app-total-record-count>
          </ng-container>

          <ng-container *ngIf="caseInfo?.caseType == 0">
            <div style="margin-top: 25px;">
              <h4 style="margin: 0px;font-weight: 500;;">Validity Test Result</h4>
            </div>

            <table class="detailTable">
              <tr>
                <th>Compound</th>
                <th>Result</th>
                <th>Concentration</th>
                <th>Comments</th>
              </tr>
              <tr *ngFor="let item of caseInfo?.caseSpecimens[0].validityCaseResults">
                <td>{{item?.compound}}</td>
                <td>{{item?.result}}</td>
                <td>{{item?.concentration + ' ' + item?.units}}</td>
                <td>{{item?.comments}}</td>
              </tr>
            </table>
          </ng-container>

          <ng-container *ngIf="caseInfo.caseType > 0">
            <div *ngIf="caseInfo.caseSpecimens[0].quantitativeResults.length > 0">
              <ejs-grid #quantitativeTestGrid [dataSource]='caseInfo.caseSpecimens[0].quantitativeResults'
                [childGrid]='quantitativeChildGrid' [enableInfiniteScrolling]='true' [allowFiltering]="true"
                [allowResizing]="true" [pageSettings]="pageSettings">
                <e-columns>
                  <e-column field='profileName' headerText='Quantitative Test' width=100></e-column>
                </e-columns>
              </ejs-grid>
              <app-total-record-count [count]="caseInfo.caseSpecimens[0].quantitativeResults.length">
              </app-total-record-count>
            </div>

            <div *ngIf="caseInfo.caseSpecimens[0].quantitativeResults.length <= 0">
              <h4 class="mt-15">Quantitative Test : No Data Available</h4>
            </div>

            <div *ngIf="caseInfo.caseSpecimens[0].qualitativeResults.length > 0" style="margin-top: 20px;">
              <ejs-grid #qualitativeTestGrid [dataSource]='caseInfo?.caseSpecimens[0]?.qualitativeResults'
                [childGrid]='qualitativeChildGrid' [enableInfiniteScrolling]='true' [allowFiltering]="true"
                [allowResizing]="true" [pageSettings]="pageSettings">
                <e-columns>
                  <e-column field='profileName' headerText='Qualitative Test' width=100></e-column>
                </e-columns>
              </ejs-grid>
              <app-total-record-count [count]="caseInfo?.caseSpecimens[0]?.qualitativeResults.length">
              </app-total-record-count>
            </div>

            <div *ngIf="caseInfo.caseSpecimens[0].qualitativeResults.length <= 0">
              <h4 class="mt-15">Qualitative Test : No Data Available</h4>
            </div>
          </ng-container>

        </mat-card-content>
      </mat-card>
    </div>

    <div *ngIf="caseInfo?.amendedCaseOrderid > 0" class="section-content" fxLayout="row wrap" fxLayout.sm="column"
      fxLayout.xs="column">
      <mat-card class="generalInfo">
        <mat-card-header>
          <mat-card-title>
            <span class="card-title-text">Amendment Info</span>
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <ul class="generalInfo_details">
            <div fxLayout="row wrap" fxLayout.sm="column" fxLayout.xs="column">
              <li fxFlex="8">Type</li>
              <li fxFlex="2"> : </li>
              <li fxFlex="40" primaryColor>
                {{caseInfo?.isCorrection ? 'Amend' : ''}}
                {{caseInfo?.isRevision ? 'Revise' : ''}}
              </li>

              <li fxFlex="8">Reason Type</li>
              <li fxFlex="2"> : </li>
              <li fxFlex="40" primaryColor>{{caseInfo?.amendmentReasonType}}</li>
            </div>

            <div fxLayout="row wrap" fxLayout.sm="column" fxLayout.xs="column">
              <li fxFlex="13">Reason (Shown on Report)</li>
              <li fxFlex="2"> : </li>
              <li fxFlex="35" primaryColor>{{caseInfo?.amendmendCaseReason}}</li>

              <li fxFlex="8">Internal Note</li>
              <li fxFlex="2"> : </li>
              <li fxFlex="40" primaryColor>{{caseInfo?.amendmentInternalNote}}</li>
            </div>
          </ul>
        </mat-card-content>
      </mat-card>
    </div>

    <div *ngIf="caseInfo?.statusFlag == 'Cancellation'" class="section-content" fxLayout="row wrap" fxLayout.sm="column"
      fxLayout.xs="column">
      <mat-card class="generalInfo">
        <mat-card-header>
          <mat-card-title>
            <span class="card-title-text">Cancellation Reason</span>
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <ul class="generalInfo_details">
            <div fxLayout="row wrap" fxLayout.sm="column" fxLayout.xs="column">
              <li fxFlex="11">Cancel By</li>
              <li fxFlex="2"> : </li>
              <li fxFlex="20" primaryColor>{{caseInfo?.createdUserName}}</li>

              <li fxFlex="11">Cancel Date</li>
              <li fxFlex="2"> : </li>
              <li fxFlex="20" primaryColor>{{caseInfo?.cancelledDate | date:'MM/dd/yyyy'}}</li>

              <li fxFlex="11">Reason</li>
              <li fxFlex="2"> : </li>
              <li fxFlex="20" primaryColor>{{caseInfo?.cancelCaseReason}}</li>
            </div>
          </ul>
        </mat-card-content>
      </mat-card>
    </div>

    <div class="section-content" fxLayout="row wrap" fxLayout.sm="column" fxLayout.xs="column">
      <mat-card class="generalInfo">
        <mat-card-header>
          <mat-card-title>
            <span class="card-title-text">Notes</span>
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <table class="detailTable">
            <tr>
              <th>Date Added</th>
              <th>Note</th>
              <th>Username</th>
            </tr>
            <tr *ngFor="let item of noteList">
              <td>{{item?.createdDate | date:"MM/dd/yyyy"}}</td>
              <td>{{item?.note}}</td>
              <td>{{item?.createdUserName}}</td>
            </tr>
          </table>
        </mat-card-content>
      </mat-card>
    </div>

    <div class="section-content" fxLayout="row wrap" fxLayout.sm="column" fxLayout.xs="column">
      <mat-card class="generalInfo">
        <mat-card-header>
          <mat-card-title>
            <span class="card-title-text">User Activity</span>
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <ul class="generalInfo_details">
            <div fxLayout="row wrap" fxLayout.sm="column" fxLayout.xs="column">
              <li fxFlex="10">Created By</li>
              <li fxFlex="2"> : </li>
              <li fxFlex="13" primaryColor>{{caseInfo?.createdUserName}}</li>

              <li fxFlex="10">Created Date</li>
              <li fxFlex="2"> : </li>
              <li fxFlex="13" primaryColor>{{caseInfo?.createdDate | date:'MM/dd/yyyy'}}</li>

              <li fxFlex="10">Last Modified By</li>
              <li fxFlex="2"> : </li>
              <li fxFlex="13" primaryColor>{{caseInfo?.modifiedUserName}}</li>

              <li fxFlex="10">Last Modified Date</li>
              <li fxFlex="2"> : </li>
              <li fxFlex="13" primaryColor>{{caseInfo?.modifiedDate | date:'MM/dd/yyyy'}}</li>
            </div>
          </ul>
        </mat-card-content>
      </mat-card>
    </div>
  </ng-container>

  <ng-container *ngIf="!isCaseOrderInfo">
    <div class="section-content" fxLayout="row wrap" fxLayout.sm="column" fxLayout.xs="column">
      <mat-card class="generalInfo">
        <mat-card-header>
          <mat-card-title>
            <span class="card-title-text">Case Info</span>
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <ul class="generalInfo_details">
            <div fxLayout="row wrap" fxLayout.sm="column" fxLayout.xs="column">
              <li fxFlex="11">Case Number</li>
              <li fxFlex="2"> : </li>
              <li fxFlex="20" primaryColor>{{caseInfo?.caseNo}}</li>

              <li fxFlex="11">Test Type</li>
              <li fxFlex="2"> : </li>
              <li fxFlex="20" primaryColor>{{caseInfo?.testTypeName}}</li>

              <li fxFlex="11">Order Date</li>
              <li fxFlex="2"> : </li>
              <li fxFlex="20" primaryColor>{{caseInfo?.createdDate | date:'MM/dd/yyyy'}}</li>
            </div>

            <div fxLayout="row wrap" fxLayout.sm="column" fxLayout.xs="column">
              <li fxFlex="11">Order Number</li>
              <li fxFlex="2"> : </li>
              <li fxFlex="20" primaryColor>{{caseInfo?.orderNo}}</li>

              <li fxFlex="11">Primary Physician</li>
              <li fxFlex="2"> : </li>
              <li fxFlex="20" primaryColor>{{caseInfo?.physicianName}}</li>

              <li fxFlex="11">Secondary Physician</li>
              <li fxFlex="2"> : </li>
              <li fxFlex="20" primaryColor>{{caseInfo?.secondaryPhysicianname}}</li>
            </div>

            <div fxLayout="row wrap" fxLayout.sm="column" fxLayout.xs="column">
              <li fxFlex="11">Case Status</li>
              <li fxFlex="2"> : </li>
              <li fxFlex="20" primaryColor>{{caseInfo?.caseStatus}}</li>
            </div>
          </ul>
        </mat-card-content>
      </mat-card>
    </div>

    <div class="section-content" fxLayout="row wrap" fxLayout.sm="column" fxLayout.xs="column">
      <mat-card class="generalInfo">
        <mat-card-header>
          <mat-card-title>
            <span class="card-title-text">Specimen Info</span>
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <ul class="generalInfo_details">
            <div fxLayout="row wrap" fxLayout.sm="column" fxLayout.xs="column">
              <li fxFlex="11">Specimen Id</li>
              <li fxFlex="2"> : </li>
              <li fxFlex="20" primaryColor>{{specimenInfo?.specimenId}}</li>

              <li fxFlex="11">Received Date</li>
              <li fxFlex="2"> : </li>
              <li fxFlex="20" primaryColor>{{specimenInfo?.dateReceived | date:'MM/dd/yyyy'}}</li>

              <li fxFlex="11">Type</li>
              <li fxFlex="2"> : </li>
              <li fxFlex="20" primaryColor>{{specimenInfo?.typeName}}</li>
            </div>

            <div fxLayout="row wrap" fxLayout.sm="column" fxLayout.xs="column">
              <li fxFlex="11">Wound Etiology</li>
              <li fxFlex="2"> : </li>
              <li fxFlex="20" primaryColor>{{specimenInfo?.etiologyName}}</li>

              <li fxFlex="11">Location</li>
              <li fxFlex="2"> : </li>
              <li fxFlex="20" primaryColor>{{specimenInfo?.specimenLocationName}}</li>

              <li fxFlex="11">Wound Orientation</li>
              <li fxFlex="2"> : </li>
              <li fxFlex="20" primaryColor>{{specimenInfo?.specimenOrientationName}}</li>
            </div>
          </ul>
        </mat-card-content>
      </mat-card>
    </div>

    <div class="section-content" fxLayout="row wrap" fxLayout.sm="column" fxLayout.xs="column">
      <mat-card class="generalInfo">
        <mat-card-header>
          <mat-card-title>
            <span class="card-title-text">Clinical Data</span>
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <ul class="generalInfo_details">
            <div fxLayout="row wrap" fxLayout.sm="column" fxLayout.xs="column">
              <li fxFlex="11">ICD Codes</li>
              <li fxFlex="2"> : </li>
              <li fxFlex="37" primaryColor>{{caseInfo?.icdCodes}}</li>

              <li fxFlex="11">Clinical History</li>
              <li fxFlex="2"> : </li>
              <li fxFlex="37" primaryColor>{{caseInfo?.clinicalHistory}}</li>
            </div>
          </ul>
        </mat-card-content>
      </mat-card>
    </div>

    <div *ngIf="caseInfo?.amendedCaseId > 0" class="section-content" fxLayout="row wrap" fxLayout.sm="column"
      fxLayout.xs="column">
      <mat-card class="generalInfo">
        <mat-card-header>
          <mat-card-title>
            <span class="card-title-text">Amendment Info</span>
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <ul class="generalInfo_details">
            <div fxLayout="row wrap" fxLayout.sm="column" fxLayout.xs="column">
              <li fxFlex="11">Type</li>
              <li fxFlex="2"> : </li>
              <li fxFlex="20" primaryColor>
                {{caseInfo?.isCorrection ? 'Amend' : ''}}
                {{caseInfo?.isRevision ? 'Revise' : ''}}
              </li>

              <li fxFlex="11">Reason Type</li>
              <li fxFlex="2"> : </li>
              <li fxFlex="20" primaryColor>{{caseInfo?.amendedReasonType}}</li>

              <li fxFlex="17">Reason (Shown on Report)</li>
              <li fxFlex="2"> : </li>
              <li fxFlex="11" primaryColor>{{caseInfo?.amendedCaseReason}}</li>
            </div>
            <div fxLayout="row wrap" fxLayout.sm="column" fxLayout.xs="column">
              <li fxFlex="11">Internal Note</li>
              <li fxFlex="2"> : </li>
              <li fxFlex="20" primaryColor>{{caseInfo?.amendmentInternalNote}}</li>
            </div>
          </ul>
        </mat-card-content>
      </mat-card>
    </div>

    <div class="section-content" fxLayout="column">
      <div><b>Insuarance Detail : </b></div>
      <div>
        <table class="detailTable">
          <tr>
            <th>Insurance type</th>
            <th>Company</th>
            <th>Policy Id</th>
            <th>Insured Name</th>
            <th>Guarantor Name</th>
            <th>No Insurance</th>
          </tr>
          <tr *ngFor="let item of insuranceInfo">
            <td>{{item?.viewInsuranceType}}</td>
            <td>{{item?.companyName}}</td>
            <td>{{item?.viewPolicyid}}</td>
            <td>{{item?.viewFullName}}</td>
            <td>{{item?.viewGuarantorName}}</td>
            <td>{{item?.viewNoInsurance}}</td>
          </tr>
        </table>
      </div>
    </div>

    <div *ngIf="caseInfo?.status == 6" class="section-content" fxLayout="row wrap" fxLayout.sm="column"
      fxLayout.xs="column">
      <mat-card class="generalInfo">
        <mat-card-header>
          <mat-card-title>
            <span class="card-title-text">Cancellation Reason</span>
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <ul class="generalInfo_details">
            <div fxLayout="row wrap" fxLayout.sm="column" fxLayout.xs="column">
              <li fxFlex="11">Cancel By</li>
              <li fxFlex="2"> : </li>
              <li fxFlex="20" primaryColor>{{caseInfo?.cancelledBy}}</li>

              <li fxFlex="11">Cancel Date</li>
              <li fxFlex="2"> : </li>
              <li fxFlex="20" primaryColor>{{caseInfo?.cancelledDate | date:'MM/dd/yyyy'}}</li>

              <li fxFlex="11">Reason</li>
              <li fxFlex="2"> : </li>
              <li fxFlex="20" primaryColor>{{caseInfo?.cancelCaseReason}}</li>
            </div>
          </ul>
        </mat-card-content>
      </mat-card>
    </div>

    <div class="section-content" fxLayout="column">
      <div><b>Tests Ordered : </b></div>
      <div>
        <table class="detailTable">
          <tr>
            <th>Name</th>
            <th>Code</th>
            <th>Status</th>
            <th>Result</th>
          </tr>
          <tr *ngFor="let item of caseTestDetails">
            <td>{{item?.testName}}</td>
            <td>{{item?.code}}</td>
            <td>{{item?.status}}</td>
            <td>{{item?.result}}</td>
          </tr>
        </table>
      </div>
    </div>
  </ng-container>

</mat-dialog-content>
<mat-dialog-actions class="popup-footer">
  <button mat-raised-button color="warn" (click)="cancelClick()">
    <i class="fas fa-times"></i> Close
  </button>
</mat-dialog-actions>